import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditTestimonialFour = () => {

    const [testimonial, setTestimonial] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/testimonial-four/${id}`)
            .then((res) => res.json())
            .then((info) => setTestimonial(info));
    }, [id]);

    const handleTestimonialSection = (event) => {
        event.preventDefault();
        const imageFour = event.target.imageFour.value;
        const personNameFour = event.target.personNameFour.value;
        const personTitleFour = event.target.personTitleFour.value;
        const descFour = event.target.descFour.value;

        const updatedTestimonial = {
            imageFour,
            personNameFour,
            personTitleFour,
            descFour
        };

        const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/testimonial-four/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(updatedTestimonial),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Testimonial is updated');
            });
    };

    return (
        <>
         
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <section className="services-area" style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-8">
                                <h3 className="mb-4 text-center">Update Testimonial</h3>

                                <form className="contact-form" onSubmit={handleTestimonialSection}>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="imageFour"
                                            placeholder="imageFour URL"
                                            defaultValue={testimonial.imageFour}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personNameFour"
                                            placeholder="Person Name"
                                            defaultValue={testimonial.personNameFour}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personTitleFour"
                                            placeholder="Person Title"
                                            defaultValue={testimonial.personTitleFour}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="descFour"
                                            placeholder="descFourription"
                                            defaultValue={testimonial.descFour}
                                            required
                                        />
                                    </div>

                                    <div className="text-center">
                                        <button className="btn btn-primary btn-lg">Update Testimonial</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default EditTestimonialFour;
